(function () {
	'use strict';

	angular
		.module('core.constants', [])
		.constant('CONFIGURATION', {
			COMPANY_NAME: 'BiFlow',
			TOOL_NAME: 'SSO',
			DOWNLOAD_TOKEN: '7svMmU7jhG873NGrgVWV'
		})
		.constant('LOCAL_STORAGE_ITEMS', {
			ACCESS_TOKEN: 'BISSOAccessToken',
			ACCESS_TOKEN_REFRESH: 'BISSORefreshToken',
			ACCESS_TOKEN_EXPIRATION: 'BISSOAccessTokenExpiration',
			ACCESS_TOKEN_OWNER: 'BISSOAccessTokenOwner',
			MENU: 'BIMenu',
			SELECTED_COMPANY: 'BISelectedCompanyId',
			APPLICATION_AUTH: 'BISSOApplicationAuth',
			APPLICATION_AUTH_EXPIRATION: 'BISSOApplicationAuthExpiration',
			CUSTOM_FILTERS: 'BISSOCustomFilters'
		})
		.constant('AUTH_EVENTS', {
			NOT_AUTHENTICATED: 'AuthNotAuthenticated'
		})
		.constant('DATA_EVENTS', {
			SELECTED_COMPANY_CHANGE: 'SelectedCompanyChange',
			USER_UPDATED: 'UserDataUpdated'
		})
		.constant('PATHS', {
			PHYSICAL: '/app/src/angular/core'
		})
		.constant('ROUTES', {
			APP: 'http://wizard-sso-local.biflow.com.br',
			API: 'http://localhost/wizard-sso/Api'
		})
		.constant('DEFAULT_IDENTIFIERS', {
			ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR: 1,
			ACCESS_LEVEL_FRANCHISER_WORKER: 2,
			ACCESS_LEVEL_FRANCHISEE: 3,
			ACCESS_LEVEL_FRANCHISEE_WORKER: 4
		})
		.constant('SYSTEM_MODULES', {
			FRANCHISEE_APPLICATION: 1,
			FRANCHISEE_UNIT: 2,
			FRANCHISEE_PEOPLE: 3,

			FRANCHISER_APPLICATION: 4,
			FRANCHISER_COMPANY: 5,
			FRANCHISER_PEOPLE: 6,
			FRANCHISER_REGIONAL: 8,
			FRANCHISER_CLUSTER: 9,
			FRANCHISER_PERMISSION_GROUP: 10,
			FRANCHISER_RESPONSIBILITY: 11,
		});
}());